import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

export default class Testimonials {
    constructor(query) {
        const el = document.querySelector(query);
        if (!el) return;

        this.el = el;
        this.swiper = null;

        this.init();
        this.handleResize();
    }

    init() {
        this.setupSwiper();
    }

    setupSwiper(activeIndex = 0) {
        const slider = this.el.querySelector('#testimonials-slider');

        if (!slider) return;

        const btnNext = this.el.querySelector('.testimonials__btn-next');
        const btnPrev = this.el.querySelector('.testimonials__btn-prev');

        if (this.swiper) {
            activeIndex = this.swiper.realIndex;
            this.swiper.destroy(true, true);
        }

        this.swiper = new Swiper(slider, {
            modules: [Navigation, Pagination, Autoplay],
            loop: true,
            slidesPerView: 1,
            spaceBetween: 20,
            centeredSlides: true,
            initialSlide: activeIndex,
            speed: 800,
            navigation: {
                nextEl: btnNext,
                prevEl: btnPrev,
            },
            autoplay: {
                delay: 4500,
            },
            pagination: {
                el: '.testimonials__pagination',
                clickable: true,
                bulletClass: 'testimonials__pagination-bullet',
                bulletActiveClass: 'testimonials__pagination-bullet-active',
            },
            breakpoints: {
                1024: {
                    slidesPerView: 3,
                    centeredSlides: true,
                },
                0: {
                    slidesPerView: 1,
                    centeredSlides: false,
                }
            }
        });
    }

    handleResize() {
        window.addEventListener('resize', () => {
            if (this.swiper) {
                this.swiper.update();
            }
        });
    }
}
